import { forwardRef } from "react";

const ErrorModal = forwardRef(function ErrorModal(_props, modalRef) {
  return (
    <dialog
      ref={modalRef}
      className="rounded-xl md:w-1/2 lg:w-1/3 border border-[#DEE2E7] dark:border-[#3D404B] backdrop:bg-black/50"
    >
      <div className="p-5">
        <div className="flex flex-col gap-3 items-center text-center">
          {/* Simple Error/Warning SVG */}
          <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-2">
            <svg
              className="w-16 h-16 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <h3 className="font-bold text-xl text-red-600">Transaction Failed</h3>

          <p className="text-gray-600 dark:text-gray-300">
            {_props.message ||
              "An unexpected error occurred. Please try again later."}
          </p>
        </div>

        <div className="w-full my-4">
          <form method="dialog">
            <button
              type="submit"
              className="w-full text-white bg-red-600 hover:bg-red-700 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center transition-colors"
            >
              Go Back
            </button>
          </form>
        </div>
      </div>
    </dialog>
  );
});

export default ErrorModal;
